module.exports = __webpack_public_path__ + "static/media/av4.c0cf7243.JPG";